module.exports = __webpack_public_path__ + "img/photo6.c3f89f16.jpg";